'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function ensureArray(x) {
  if (x == null) return [];
  return Array.isArray(x) ? x : [x];
}

function NestableRecord(defaultValues, types, name) {
  var _RecordType = _immutable2['default'].Record(defaultValues, name);

  function NestableRecordType(values) {
    if (values instanceof _RecordType) return values;

    var _values = values || defaultValues;
    var newValues = _extends({}, _values);

    var _loop = function (key) {
      var _value = _values[key];
      if (_value == null) return 'continue';

      var type = ensureArray(types[key]);

      var f = function f(i, v) {
        var res = type[i](v);

        if (type[i + 1]) {
          return res.map(function (x) {
            return f(i + 1, x);
          });
        }

        return res;
      };

      newValues[key] = f(0, _value);
    };

    for (var key in types) {
      var _ret = _loop(key);

      if (_ret === 'continue') continue;
    }

    return _RecordType(newValues);
  }

  NestableRecordType.prototype = _RecordType.prototype;
  NestableRecordType.prototype.constructor = NestableRecordType;

  return NestableRecordType;
}

exports['default'] = NestableRecord;
module.exports = exports['default'];